import React, {memo, useState} from "react";
import {useSelector} from 'react-redux';
import ArchiveBlock from "./archive-block";
import RssButton from "./rss-button";
import ButtonCreateLot from './button-create-lot';
import useTopBarButtonFn from "./useTopBarButtonFn";
import SubscriptionCategory from "./subscription-category";
import SubscriptionCategoryPrefix from "./subscription-category-prefix";
import './archive-subscription-rss-block.css';

const MemoButtonCreateLot = memo(ButtonCreateLot);
const MemoArchiveBlock = memo(ArchiveBlock);
const MemoRssButton = memo(RssButton);
const MemoFollowCategory = memo(SubscriptionCategory);

const ArchiveSubscriptionRssBlock = () => {
    const { visitor_user_id, prefix_id, auction_category_id } = useTopBarButtonFn();
    const [isExpanded, setIsExpanded] = useState(false);
    
    const { phrases: { ak_au_ph_menu_categories } } = useSelector((state) => state.lots);

    return (
        <div className="row mb-1">
            <div className="col-12">
                <div className="section-main">
                    <div className="m-2">
                        {/* Мобильная версия - с возможностью раскрытия */}
                        <div className="d-md-none">
                            {/* Раскрывающийся блок с кнопками */}
                            <div className={`mobile-buttons-container ${isExpanded ? 'expanded' : 'collapsed'}`}>
                                {/* Кнопка переключения - теперь первая */}
                                <button 
                                    className="mobile-buttons-toggle"
                                    onClick={() => setIsExpanded(!isExpanded)}>
                                    <span className="toggle-icon">▼</span>
                                    <span className="toggle-text">{ak_au_ph_menu_categories}</span>
                                </button>
                                
                                {/* Скрываемые кнопки - теперь под кнопкой */}
                                <div className="mobile-buttons-content">
                                    {/* Первая строка: Архив и RSS */}
                                    <div className="mobile-button-row d-flex justify-content-center mb-2">
                                        <MemoArchiveBlock />
                                        <MemoRssButton/>
                                    </div>
                                    
                                    {/* Кнопки подписок - каждая на своей строке */}
                                    {visitor_user_id && auction_category_id ? (
                                        <div className="mobile-button-row d-flex justify-content-center w-100 mb-2">
                                            <MemoFollowCategory/>
                                        </div>
                                    ) : null}
                                    {visitor_user_id && prefix_id ? (
                                        <div className="mobile-button-row d-flex justify-content-center w-100 mb-2">
                                            <SubscriptionCategoryPrefix/>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            
                            {/* Кнопка "Создать лот" - под раскрывающимся блоком */}
                            {visitor_user_id ? (
                                <div className="mobile-main-button">
                                    <div className="d-flex justify-content-center w-100">
                                        <MemoButtonCreateLot/>
                                    </div>
                                </div>
                            ): null}
                        </div>
                        
                        {/* Десктопная верстка (без изменений) */}
                        <div className="d-none d-md-flex justify-content-between flex-wrap-reverse">
                            <div>
                                <MemoButtonCreateLot/>
                            </div>
                            <div className="d-flex mb-2 mb-sm-0">
                                <MemoArchiveBlock />
                                {visitor_user_id && auction_category_id ? <MemoFollowCategory/> : null}
                                {visitor_user_id && prefix_id ? <SubscriptionCategoryPrefix/> : null}
                                <MemoRssButton/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArchiveSubscriptionRssBlock;
